async function generateSignature (userID) {
  const timestamp = Math.floor(Date.now() / 1000)
  const secret = process.env.VUE_APP_DO_SIGNING_SECRET
  const encoder = new TextEncoder()
  const key = await crypto.subtle.importKey(
    'raw', encoder.encode(secret), { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']
  )
  const sig = await crypto.subtle.sign('HMAC', key, encoder.encode(`${timestamp}:${userID}`))
  const hmac = Array.from(new Uint8Array(sig)).map(b => b.toString(16).padStart(2, '0')).join('')
  return `${hmac}:${timestamp}`
}

export { generateSignature }
